/* 图片静态资源表 */

/* 基本 */
import text from '@/assets/editor/text.png'
import number from '@/assets/editor/numerical-display.png'
import button from '@/assets/editor/button.png'

/* 管道 */
import gd_horizontal_pipe from '@/assets/editor/gd-horizontal-pipe.svg'
import gd_left_bottom from '@/assets/editor/gd-left-bottom.svg'
import gd_left_top from '@/assets/editor/gd-left-top.svg'
import gd_right_bottom from '@/assets/editor/gd-right-bottom.svg'
import gd_right_top from '@/assets/editor/gd-right-top.svg'
import gd_vertical_pipe from '@/assets/editor/gd-vertical-pipe.svg'

/* 主机 */
import l_zuji_off from '@/assets/editor/l_zuji_off.png'
import l_zuji_on from '@/assets/editor/l_zuji_on.png'
import n_zuji_off from '@/assets/editor/n_zuji_off.png'
import n_zuji_on from '@/assets/editor/n_zuji_on.png'

/* 冷却阀、冷却塔 */
import lengquefa_off from '@/assets/editor/lengquefa-off.png'
import lengquefa_on from '@/assets/editor/lengquefa-on.png'
import lengqueta_off from '@/assets/editor/lengqueta.png'
import lengqueta_gif from '@/assets/editor/lengqueta.gif'

/* 水泵 */
import shuibeng1_off from '@/assets/editor/shuibeng1.png'
import shuibeng1_gif from '@/assets/editor/shuibeng1.gif'
import shuibeng2_off from '@/assets/editor/shuibeng2.png'
import shuibeng2_gif from '@/assets/editor/shuibeng2.gif'

// 集水器分水器
import jishuiqi from '@/assets/editor/jishuiqi.png'
import flow_h from '@/assets/editor/flow-h.svg'
import flow_v from '@/assets/editor/flow-v.svg'

import reddot from '@/assets/editor/reddot.png'

export default {
    /* 机房设备图 */
    text, number, button, reddot, 
    gd_horizontal_pipe, gd_left_bottom, gd_left_top, gd_right_bottom, gd_right_top, gd_vertical_pipe, l_zuji_off, l_zuji_on,
    n_zuji_off, n_zuji_on, lengquefa_off, lengquefa_on, lengqueta_off, lengqueta_gif, shuibeng1_off, shuibeng1_gif,
    shuibeng2_off, shuibeng2_gif, jishuiqi, flow_h, flow_v,
}